export const calculateClassementPoule = (competiteurs, combats) => {
  const classementMap = {};

  competiteurs.forEach((competiteur) => {
    const id = Number(competiteur.id);
    classementMap[id] = {
      id,
      nom_competiteur: competiteur.nom_competiteur,
      prenom_competiteur: competiteur.prenom_competiteur,
      victoires: 0,
      points: 0,
      disqualifie: false, // vraie exclusion compétition uniquement
      hansokuMake: false, // info combat / affichage
      exAequo: false,
    };
  });

  combats.forEach((combat) => {
    const id1 = Number(combat.competiteur_id1);
    const id2 = Number(combat.competiteur_id2);

    const c1 = classementMap[id1];
    const c2 = classementMap[id2];
    if (!c1 || !c2) return;

    const r1 = combat.resultat_competiteur1;
    const r2 = combat.resultat_competiteur2;
    const p1 = Number(combat.points_competiteur1) || 0;
    const p2 = Number(combat.points_competiteur2) || 0;

    // Hansoku Make = info combat, pas exclusion tournoi automatique
    if (r1 === "H") c1.hansokuMake = true;
    if (r2 === "H") c2.hansokuMake = true;

    c1.points += p1;
    c2.points += p2;

    if (r1 === "V") c1.victoires += 1;
    if (r2 === "V") c2.victoires += 1;

    // Ici seulement si tu as un vrai flag métier envoyé par le back
    if (combat.disqualification_scope === "competition") {
      if (combat.disqualified_competiteur_id) {
        const dqId = Number(combat.disqualified_competiteur_id);
        if (classementMap[dqId]) {
          classementMap[dqId].disqualifie = true;
        }
      }
    }
  });

  let sortedClassement = Object.values(classementMap)
    .filter((competiteur) => !competiteur.disqualifie)
    .sort((a, b) => b.victoires - a.victoires || b.points - a.points);

  let currentPosition = 1;
  let previousVictoires = null;
  let previousPoints = null;

  sortedClassement.forEach((competiteur, index) => {
    if (
      previousVictoires !== null &&
      competiteur.victoires === previousVictoires &&
      competiteur.points === previousPoints
    ) {
      competiteur.position = currentPosition;
      competiteur.exAequo = true;
      sortedClassement[index - 1].exAequo = true;
    } else {
      currentPosition = index + 1;
      competiteur.position = currentPosition;
      competiteur.exAequo = false;
    }

    previousVictoires = competiteur.victoires;
    previousPoints = competiteur.points;
  });

  const disqualified = Object.values(classementMap).filter(
    (competiteur) => competiteur.disqualifie
  );

  return [...sortedClassement, ...disqualified];
};